module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhand5-6b2ee01ef790fd432321f65c8a289a63.jpg";